module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reject-driver-request-buttons"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.start,
      "confirm": "confirm"
    }
  }, [_vm._v("Start")]), _c('ActionButton', {
    attrs: {
      "action": _vm.end,
      "confirm": "confirm"
    }
  }, [_vm._v("End")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-142cadb8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/ChargingSessionButtons.vue
// module id = 2290
// module chunks = 1